import { type ComponentProps } from "solid-js"

export const Mark = (props: { class?: string }) => {
  return (
    <svg
      data-component="logo-mark"
      classList={{ [props.class ?? ""]: !!props.class }}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path data-slot="logo-logo-mark-shadow" d="M12 16H4V8H12V16Z" fill="var(--icon-weak-base)" />
      <path data-slot="logo-logo-mark-o" d="M12 4H4V16H12V4ZM16 20H0V0H16V20Z" fill="var(--icon-strong-base)" />
    </svg>
  )
}

export const Splash = (props: Pick<ComponentProps<"svg">, "ref" | "class">) => {
  return (
    <svg
      ref={props.ref}
      data-component="logo-splash"
      classList={{ [props.class ?? ""]: !!props.class }}
      viewBox="0 0 80 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M60 80H20V40H60V80Z" fill="var(--icon-base)" />
      <path d="M60 20H20V80H60V20ZM80 100H0V0H80V100Z" fill="var(--icon-strong-base)" />
    </svg>
  )
}

// opentag: piksel yazı tipinde "opentag" (open = temel, tag = vurgulu). Harfler 24 birim genişlikte, 6 birim aralıklı.
export const Logo = (props: { class?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 204 48"
      fill="none"
      classList={{ [props.class ?? ""]: !!props.class }}
    >
      <g>
        <path d="M18 30H6V18H18V30Z" fill="var(--icon-weak-base)" />
        <path d="M18 12H6V30H18V12ZM24 36H0V6H24V36Z" fill="var(--icon-base)" />
        <path d="M48 30H36V18H48V30Z" fill="var(--icon-weak-base)" />
        <path d="M36 30H48V12H36V30ZM54 36H36V42H30V6H54V36Z" fill="var(--icon-base)" />
        <path d="M84 24V30H66V24H84Z" fill="var(--icon-weak-base)" />
        <path d="M84 24H66V30H84V36H60V6H84V24ZM66 18H78V12H66V18Z" fill="var(--icon-base)" />
        <path d="M108 36H96V18H108V36Z" fill="var(--icon-weak-base)" />
        <path d="M108 12H96V36H90V6H108V12ZM114 36H108V12H114V36Z" fill="var(--icon-base)" />
        <path d="M132 18h6v12h-6Z" fill="var(--icon-weak-base)" />
        <path d="M126 0h6v36h-6Z M120 6h24v6h-24Z M132 30h12v6h-12Z" fill="var(--icon-strong-base)" />
        <path d="M156 24h12v6h-12Z" fill="var(--icon-weak-base)" />
        <path d="M150 6h24v6h-24Z M168 12h6v6h-6Z M150 18h24v6h-24Z M150 24h6v6h-6Z M168 24h6v6h-6Z M150 30h24v6h-24Z" fill="var(--icon-strong-base)" />
        <path d="M186 18h12v12h-12Z" fill="var(--icon-weak-base)" />
        <path d="M180 6h24v6h-24Z M180 12h6v18h-6Z M198 12h6v30h-6Z M180 30h24v6h-24Z M180 42h24v6h-24Z" fill="var(--icon-strong-base)" />
      </g>
    </svg>
  )
}
